import { createSelector } from 'reselect';


const invitations = (store) => store.apps.invitations;

const containerSelector = createSelector([
  invitations,
],
(filteredState) => ({
  invitation: filteredState.invitations.get('invitation'),
  loading: filteredState.invitations.get('loading'),
}));


export default containerSelector;
export {
  containerSelector,
  invitations,
};
